module.exports = __webpack_public_path__ + "img/2.4b4a89f5.png";